import { RouteMeta } from 'vue-router';
import { Component, Vue, Watch } from 'vue-property-decorator';
import styles from './Breadcrumb.module.scss';
import WithRender from './Breadcrumb.html';
// models
import { BreadCrumbModel } from '@/models/breadcrumb';

@WithRender
@Component
export default class BreadCrumb extends Vue {
  public styles = styles;
  public showBreadCrumb = false;

  public baseBreadcrumb: BreadCrumbModel[] = [];
  public breadcrumbs: BreadCrumbModel[] = [];

  public get isHighlighted() {
    const { path } = this.$route;
    const dynamicallyHighlightedFromRouter = this.getRouteMeta()?.highlighted || false;
    const highlightedRoutes: string[] = [];

    return highlightedRoutes.includes(path.toLocaleLowerCase()) || dynamicallyHighlightedFromRouter;
  }

  async mounted() {
    this.appendDynamicBreadcrumbs();
  }

  public appendDynamicBreadcrumbs() {
    const initialBreadCrumbs = [
      {
        href: '/',
        text: this.$t('home') as string,
      },
    ];

    this.breadcrumbs = [...initialBreadCrumbs];
    this.baseBreadcrumb = [...initialBreadCrumbs];

    this.updateBreadCrumbs();
  }

  @Watch('$route')
  public updateBreadCrumbs() {
    this.showBreadCrumb = this.$route.path !== '/';

    let enhancedBreadcrumbs: BreadCrumbModel[] = [...this.baseBreadcrumb];

    this.$route.matched.forEach((route) => {
      const enhancedMeta = this.getRouteMeta(route);

      const hasBreadcrumb = 'breadcrumb' in enhancedMeta;

      if (hasBreadcrumb) {
        enhancedBreadcrumbs = enhancedBreadcrumbs.concat(enhancedMeta.breadcrumb);
      } else {
        enhancedBreadcrumbs = [...this.baseBreadcrumb];
      }
    });

    // ? update [disabled/external] prop
    this.breadcrumbs = enhancedBreadcrumbs.map((route, index) => ({
      ...route,
      external: route.external || false,
      disabled: index === (enhancedBreadcrumbs.length - 1),
    }));
  }

  public getRouteMeta(route: RouteMeta = this.$route): RouteMeta {
    const { meta } = route;

    return typeof meta === 'function' ? meta(this.$route) : meta;
  }

  public onClickBreadcrumb(route: BreadCrumbModel) {
    this.$router.push(route.href || '');
  }
}
